import React from 'react';

const LoadingDots = ({ message = 'Loading...' }) => (
    <div className="flex flex-col items-center justify-center min-h-screen text-gray-700 dark:text-slate-300">
        <div className="mb-5 text-lg font-medium">{message}</div>
        <div className="flex space-x-5 text-blue-500 text-4xl">
            <span className="animate-bounce">•</span>
            <span className="animate-bounce animation-delay-150">•</span>
            <span className="animate-bounce animation-delay-300">•</span>
        </div>
    </div>
);
export default LoadingDots;